// import React from 'react';
// import SecondNav from "../Navbar/SecondNav";
// import TopNavbar from "../Navbar/TopNavbar";


// function Gallery() {
//   return (
//     <div
//       className="home-page"
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         backgroundColor: "#f5f5f5",
//       }}
//     >
//       <TopNavbar />
//       <SecondNav />
         
      
    
//     </div>
//   );
// }

// export default Gallery;


import React from 'react';
import './Gallery.css';
import TopNavbar from '../Navbar/TopNavbar';
import SecondNav from '../Navbar/SecondNav';
import Footer from './Footer';
import ChatPopup from './ChatPopup';

const galleryItems = [
  {
    id: 1,
    src: 'https://media.istockphoto.com/id/1310978724/photo/the-washing-process-on-a-self-service-car-wash.jpg?b=1&s=612x612&w=0&k=20&c=4tzXceGd1Tb1l9yTbGpnA4G0gKY3gc7XV_l1b_gCzK8=',
    alt: 'Luxury Sedan - After Full Service',
  },
  {
    id: 2,
    src: 'https://media.istockphoto.com/id/451803261/photo/car-washing.jpg?b=1&s=612x612&w=0&k=20&c=qRvktywmef_AG7cD5u8q4mM6HwfvyPZxfVr9xfn3knY=',
    alt: 'SUV Exterior Polish',
  },
  {
    id: 3,
    src: 'https://media.istockphoto.com/id/1273682054/photo/car-service-worker-applying-nano-coating-on-a-car-detail.jpg?b=1&s=612x612&w=0&k=20&c=cb-aDsIYVzLl6uAuuBrH7oylNROgCn44absngBChEVU=',
    alt: 'Interior Detailing Completed',
  },
  {
    id: 4,
    src: 'https://images.pexels.com/photos/3764984/pexels-photo-3764984.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    alt: 'Classic Car Restoration',
  },
  
];


function Gallery() {
  return (
    <div className="home-page">
      <TopNavbar/>
      <SecondNav/>

      <div className="gallery-container">
  <h2 className="gallery-title">Our Featured Cars</h2>
  <p className="gallery-desc">
    <strong>Explore our collection of beautifully maintained and serviced cars. Cleaned, polished, and ready to roll!</strong>
  </p>

  <div className="gallery-grid">
    {galleryItems.map((item) =>
      item.type === 'video' ? (
        <video key={item.id} controls className="gallery-video">
          <source src={item.src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          key={item.id}
          src={item.src}
          alt={item.alt}
          className="gallery-img"
        />
      )
    )}
  </div>
      </div>


             {/* book  */}
             <div
  className="booking-section"
  style={{
    background: 'linear-gradient(135deg,rgb(7, 13, 53), #203a43,rgb(11, 74, 146))',
    color: '#ffffff',
    padding: '70px 20px',
    textAlign: 'center',
    marginTop: '40px',
    marginBottom: '80px',
    borderRadius: '150px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5)',
    fontFamily: "'Segoe UI', sans-serif",
  }}
>
  <h2
    style={{
      fontSize: '2.8rem',
      marginBottom: '20px',
      color: '#e3f2fd',
      fontWeight: 'bold',
      textShadow: '2px 2px 4px rgba(0,0,0,0.4)',
    }}
  >
    Premium Car Wash Services
  </h2>

  <p
    style={{
      fontSize: '1.2rem',
      marginBottom: '30px',
      color: '#e0e0e0',
      maxWidth: '650px',
      margin: '0 auto',
      lineHeight: '1.6',
    }}
  >
    Refresh your car with our expert detailing team. Fast, eco-friendly, and professional service tailored just for you.
  </p>

  <button
    style={{
      backgroundColor: '#e3f2fd',
      color: '#000',
      padding: '14px 36px',
      fontSize: '1rem',
      border: 'none',
      borderRadius: '10px',
      fontWeight: 'bold',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#e6b800';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#FFD700';
      e.target.style.transform = 'scale(1)';
    }}
  >
    Book Now
  </button>

  <div style={{ marginTop: '30px' }}>
    <ChatPopup />
  </div>
</div>





      <Footer/>
    </div>
  );
}

export default Gallery;
